import './SelectionSnackbar.scss'
import {Button, ButtonGroup, CircularProgress, Snackbar, Tooltip, Typography} from "@mui/material";
import React, {MouseEventHandler, useContext} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../../stores";
import {Check, Close, Edit, Warning} from "@mui/icons-material";
import {CategoryMenuControllerContext} from "../../../context/CategoryMenuController";
import {ReviewChoice} from "../../../../../services/classes/MaterializedClasses";
import {plural} from "../../../../../utils/js-utils";
import {PART_NAME, SUPPLIER_NAME} from "./SelectionMessages";

type Props = {}
export const SelectionSnackbar: React.FC<Props> = observer(() => {
    const {categorizationReviewStore} = useStores()
    const controller = useContext(CategoryMenuControllerContext);
    const reviewPageController = categorizationReviewStore.reviewPageController;
    const reviewPageSelectionController = categorizationReviewStore.reviewPageController.reviewPageSelectionController;
    const c = reviewPageSelectionController;

    const isOpen = reviewPageSelectionController.isAnySelected;

    const handleClose = () => reviewPageSelectionController.onSetAllSelected(false);

    const handleEditCategory: MouseEventHandler<HTMLButtonElement> = event => {
        if (!controller) {
            console.error('No controller set');
            return;
        }
        const anchor = event.currentTarget;
        controller.setOnSelect(c => reviewPageController.onClickReCategorizeSelection(c.data.labels))
        controller.open(
            anchor,
            {vertical: 'top', horizontal: 'center'},
            {vertical: 'bottom', horizontal: 'center'},
            true,
        )
    }
    const handleAcceptCategory = () => reviewPageController.onClickAcceptRejectSelection(ReviewChoice.ACCEPT);

    const P = PART_NAME;
    const S = SUPPLIER_NAME;

    const txtHelp = '';
    const editHelp = c.editCategoryAlertMessage.msg;
    const editWarning = c.editCategoryAlertMessage.warning;
    const editDisabled = c.editCategoryAlertMessage.disabled ?? false;
    const acceptHelp = c.acceptCategoryAlertMessage.msg;
    const acceptWarning = c.acceptCategoryAlertMessage.warning;
    const acceptDisabled = c.acceptCategoryAlertMessage.disabled ?? false;
    const isSingle = reviewPageController.singleMode;
    return <Snackbar open={isOpen} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
        <div id="dark-selection-snackbar">
            <ButtonGroup variant="contained">

                <Button className="first" onClick={handleClose}>
                    <Close/>
                </Button>

                <Tooltip title={txtHelp} placement="top" arrow>
                    <div className="button-group-text" style={{minWidth: isSingle ? '17em' : '27em'}}>
                        {c.selectionIsLoading && <CircularProgress size=".75rem"/>}
                        <Typography variant="body2">
                            {isSingle
                                ? <>
                                    <span className="highlight">{c.totalSelectedParts}</span>
                                    {' of '}
                                    <span className="highlight">{c.totalParts}</span> selected
                                </>
                                : <>
                                    {!c.selectionIsLoading && <>
                                        <span className="highlight">{c.totalSelectedGroups}</span>
                                        {` ${plural(S, c.totalSelectedGroups)}`}
                                        {' ('}
                                        <span className="highlight">{c.totalSelectedParts}</span>
                                        {` ${plural(P, c.totalSelectedParts)}`}
                                        {') selected'}
                                    </>}
                                </>
                            }
                        </Typography>
                    </div>
                </Tooltip>

                <Tooltip title={editHelp} placement="top" arrow>
                    <div className="grouped-tooltip-root">
                        <Button
                            className="border-left"
                            style={{minWidth: '19em'}}
                            onClick={handleEditCategory}
                            disabled={editDisabled}
                            startIcon={<Edit/>}
                            endIcon={editWarning ? <Warning/> : undefined}>
                            Change Category
                        </Button>
                    </div>
                </Tooltip>

                <Tooltip title={acceptHelp} placement="top" arrow>
                    <div className="grouped-tooltip-root">
                        <Button
                            className="last border-left"
                            style={{minWidth: '19em'}}
                            onClick={handleAcceptCategory}
                            disabled={acceptDisabled}
                            startIcon={<Check/>}
                            endIcon={acceptWarning ? <Warning/> : undefined}>
                            Accept Suggestion
                        </Button>
                    </div>
                </Tooltip>
            </ButtonGroup>
        </div>
    </Snackbar>
})
